/* eslint-disable react/require-default-props */
import React from 'react';
import { oneOf, string, node } from 'prop-types';
import cn from 'classnames';
import './Heading.scss';

var Heading = function Heading(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#846550' : _ref$color,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId;
  var TypographyHeading = "h".concat(variant);
  return /*#__PURE__*/React.createElement(TypographyHeading, {
    className: "".concat(cn(TypographyHeading, 'scl-heading', className)),
    style: {
      color: "".concat(color)
    },
    "data-test-id": "scl-heading",
    "data-analytics-id": dataAnalyticsId
  }, children);
};

Heading.propTypes = {
  /**
  Required for determining size of heading.
  If 1 is chosen, the rendered Heading is an h1
  */
  variant: oneOf([1, 2, 3, 4, 5, 6]).isRequired,

  /**
  Required and refers to everything included between opening
  and closing tags when invoking component
  */
  children: node.isRequired,

  /**
  Optional className to include in rendered component
  */
  className: string,

  /**
  Optional for changing font color
  */
  color: string,

  /**
   Optional id for analytics tracking. Must be included if using
   Heading as a link.
  */
  dataAnalyticsId: string
};
export default Heading;